import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    angular
        .module('app')
        .directive(
            'pkpMinimumLotRuntimeValidatorResponse',
            pkpMinimumLotRuntimeValidatorResponse
        );

    /**
     *
     * @author haprecht.btc
     * @ngInject
     */
    function pkpMinimumLotRuntimeValidatorResponse(createProposalService) {
        return {
            restrict: 'A',
            link: linkFn
        };

        function linkFn(scope, element, attr) {
            scope.$watchGroup(
                [
                    function () {
                        var pkpMinimumLotRuntimeValidatorResponseEvaluated =
                            scope.$eval(
                                attr.pkpMinimumLotRuntimeValidatorResponse
                            );
                        if (pkpMinimumLotRuntimeValidatorResponseEvaluated) {
                            return pkpMinimumLotRuntimeValidatorResponseEvaluated.start;
                        }
                    },
                    function () {
                        var pkpMinimumLotRuntimeValidatorResponseEvaluated =
                            scope.$eval(
                                attr.pkpMinimumLotRuntimeValidatorResponse
                            );
                        if (pkpMinimumLotRuntimeValidatorResponseEvaluated) {
                            return pkpMinimumLotRuntimeValidatorResponseEvaluated.end;
                        }
                    }
                ],
                function () {
                    var VALID_STATE_ATTR_NAME = 'minimumLotRuntimeViolation';

                    var newRuntime = scope.$eval(
                        attr.pkpMinimumLotRuntimeValidatorResponse
                    );

                    if (!newRuntime) {
                        return;
                    }

                    var startDate = moment(newRuntime.start);
                    var endDate = moment(newRuntime.end);

                    var minimumLotRuntime = scope.$eval(attr.lotRuntime);
                    var lotValue = minimumLotRuntime.value;
                    var type = minimumLotRuntime.type;

                    var fitMinimumLotRuntime = checkMinimumLotRuntime(
                        startDate,
                        endDate,
                        lotValue,
                        type
                    );

                    var splitScopeHierarchy = attr[VALID_STATE_ATTR_NAME].split(
                        VALID_STATE_ATTR_NAME
                    );
                    if (splitScopeHierarchy.length < 1) {
                        return; // There's no VALID_STATE_ATTR_NAME
                    }

                    var scopeMinimumLotRuntimeViolation =
                        splitScopeHierarchy[0] + VALID_STATE_ATTR_NAME;
                    assignProperty(
                        scope,
                        scopeMinimumLotRuntimeViolation,
                        !fitMinimumLotRuntime
                    );
                }
            );
        }

        function checkMinimumLotRuntime(startDate, endDate, lotValue, type) {
            var valid = true;

            var completeRuntime = createProposalService.isCompleteRuntime(
                { start: startDate.toISOString(), end: endDate.toISOString() },
                { type: type, value: lotValue }
            );

            if (completeRuntime) {
                return true;
            }

            switch (type) {
                case 'HOUR': {
                    var hours = endDate.diff(startDate, 'hours');
                    if (!isMultiple(hours, lotValue)) {
                        valid = false;
                    }
                    break;
                }
                case 'DAY': {
                    //duration in gas day
                    if (!isMultipleDays(startDate, endDate, lotValue)) {
                        valid = false;
                    }
                    break;
                }
                case 'MONTH': {
                    if (!isMultipleMonths(startDate, endDate, lotValue)) {
                        valid = false;
                    }
                    break;
                }
                default: {
                    valid = false;
                    break;
                }
            }

            return valid;
        }

        function isMultiple(value, part) {
            return value / part > 0 && value % part === 0;
        }

        function isSameTime(startDate, endDate) {
            var check =
                startDate.get('hour') === endDate.get('hour') &&
                startDate.get('minute') === endDate.get('minute') &&
                startDate.get('seconds') === endDate.get('seconds') &&
                startDate.get('milliseconds') == endDate.get('milliseconds');
            return check;
        }

        function isMultipleDays(startDate, endDate, lotValue) {
            var days = endDate.diff(startDate, 'days');
            return isMultiple(days, lotValue) && isSameTime(startDate, endDate);
        }

        function isMultipleMonths(startDate, endDate, lotValue) {
            var months = endDate.diff(startDate, 'months');
            return (
                isMultiple(months, lotValue) &&
                startDate.format('D') === endDate.format('D') &&
                isSameTime(startDate, endDate)
            );
        }

        /**
         * Change JSON node when the path to the JSON node is available <tt>as.a.dotted.string</tt>.
         * This way you can say i.e. <tt>scope['dotted.string']</tt> and have it converted to
         * <tt>{scope: {dotted: {string: {}}}}</tt> whereas it would actually be <tt>{scope: 'dotted.string}</tt>.
         *
         * @see http://stackoverflow.com/a/28058601
         * @param obj {Object} The JSON do find the path in.
         * @param path {String} The dotted string to search the path for.
         * @param value {*} The value to assign to <tt>obj.path</tt>.
         */
        function assignProperty(obj, path, value) {
            var props = path.split('.');
            var i = 0;
            var prop = null;

            for (; i < props.length - 1; i++) {
                prop = props[i];
                obj = obj[prop];
            }

            obj[props[i]] = value;
        }
    }
})();
